'use client';

import { FC } from 'react';

import { Source_Sans_3 } from 'next/font/google';

import { useGlobalErrorHandler } from '@hooks/useGlobalErrorHandler';
import theme, { ThemeProvider } from '@utils/theme';
import InternalServerError from '@components/utils/internal-server-error';

const sourceSans3 = Source_Sans_3({
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700', '900'],
  display: 'swap',
  variable: '--font-source-sans',
});

interface ErrorWrapperProps {
  error: Error & { digest?: string };
}

const GlobalError: FC<ErrorWrapperProps> = ({ error }) => {
  const { eventId } = useGlobalErrorHandler(error);

  return (
    <html lang='tr' className={`${sourceSans3.className}`}>
      <head>
        <link rel='shortcut icon' href='/favicon.ico' />
        <title>Setur’dan güvenle al, tatilde kal! | Setur</title>
        <meta
          name='description'
          content='Seyahate dair istediğin ne varsa gerçek olması için tam 58 yıldır Setur yanında! Hemen otel ve turları incele, tatil fırsatlarını kaçırma.'
        />
        <meta
          name='viewport'
          content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
        />
      </head>
      <body>
        <ThemeProvider theme={theme}>
          <InternalServerError eventId={eventId} error={error?.message} />
        </ThemeProvider>
      </body>
    </html>
  );
};

export default GlobalError;
